<p>primary-care-clinics works!</p>
<router-outlet></router-outlet>